// method to fill a range of array with a number starting at start ending at end
export default (start = 0, end = 100) =>
  new Array(end - start + 1).fill().map((item, index) => start + index);
